import {StyledDialog} from './style'
import {AgendaEventDetailsFormProvider} from '@/features/agenda/components/agenda-event-form/agenda-event-details-form-provider/AgendaEventDetailsFormProvider'
import {AgendaEventDetailsErrorDialog} from './AgendaEventDetailsErrorDialog'
import {AgendaEventDetailsLoaderDialog} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsLoaderDialog'
import {useAgendaEvent} from '@/features/agenda/hooks/useAgendaEvent'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {AgendaEventDetailsDialogFooter} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialogFooter'
import {AgendaEventDetailsDialogBody} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialogBody'
import {AgendaEventDetailsDialogHeader} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialogHeader'

export const AgendaEventDetailsDialog = ({eventId}: {eventId: string}) => {
    return (
        <StyledDialog width="680px" overflowY="visible">
            <AgendaEventDetailsFormDialogContent eventId={eventId} />
        </StyledDialog>
    )
}

const AgendaEventDetailsFormDialogContent = ({eventId}: {eventId: string}) => {
    const {agendaEvent, agendaEventDefaultValues, data, error, refetch, isPending, isFetching, isError} =
        useAgendaEvent({
            eventId
        })
    if (isFetching || isPending) {
        return <AgendaEventDetailsLoaderDialog />
    }

    if (isError || !agendaEvent || agendaEvent.type !== 'event') {
        return <AgendaEventDetailsErrorDialog error={error} refetch={refetch} isFetching={isFetching} />
    }

    const repetitionData =
        agendaEventDefaultValues?.category == 'treatments' ? agendaEventDefaultValues?.repetitionData : undefined

    return (
        <AgendaEventDetailsFormProvider defaultValues={agendaEventDefaultValues}>
            <AgendaEventDetailsDialogHeader
                agendaEvent={agendaEvent}
                isARecovery={!!agendaEventDefaultValues?.isARecovery}
            />
            <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                <AgendaEventDetailsDialogBody event={data} />
            </ScrollArea>
            <AgendaEventDetailsDialogFooter agendaEvent={agendaEvent} repetitionData={repetitionData} />
        </AgendaEventDetailsFormProvider>
    )
}
